import { Box, Button, FormControl, ListItemText, MenuItem, Modal, Select } from '@mui/material';
import React, { useEffect, useState } from 'react';
import FormControlProfile from '../../FormControlProfile/Index';
import { APIDataUrl, APITokenUrl, GetUserId } from '../../../Utils/Utils';
import axios from 'axios';
import DataEnrichOrgResult from './DataEnrichOrgResult';
import Loader from '../../Loader/Loader';
import { toast } from 'react-toastify';
const DataEnrichOrgModal = ({ modalOpen, handleClose, setFile,
  file, setOrgUploadModal, setIsOrgModalOpen, filepath, getEnrichList,
  authorizedPerson, setAuthorizedPerson, setDisclaimerOne, setDisclaimerTwo }) => {
  const [loading, setLoading] = useState(false);
  const userId = GetUserId();

  const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: 400,
    bgcolor: "background.paper",
    boxShadow: 24,
    borderRadius: "8px",
  };
  const liveScoreData = [
    { label: "Event", value: "Event" },
    { label: "Purchased", value: "Purchased" },
    { label: "Other", value: "Other" }
  ]

  const [enrichList, setEnrichList] = useState("");
  const [listSource, setListSource] = useState();
  const [enrichListFrom, setEnrichListFrom] = useState("");

  const [resultModalOpen, setResultModalOpen] = useState(false);
  const [resultTableData, setResultTableData] = useState(false);
  const headersList = file?.column_names || [];
  // Track selected values for FormControlProfile dropdowns
  const [selectedValues, setSelectedValues] = useState({
    organization: "",
    website: "",
    linkedInURL: "",
    streetAddress: "",
    city: "",
    state: "",
    zipCode: "",
    country: ""
  });

  const requestId = file?.request_id || [];
  const validate = () => {
    if (!selectedValues.organization) {
      toast.error("Please select Organization");
      return false;
    } else if (!selectedValues.website && !selectedValues.linkedInURL) {
      toast.error("Please select one of the below two options");
      return false;
    }
    else if (!listSource || listSource?.trim() === "") {
      toast.error("Please select list comes from");
      return false;
    }
    else if (!enrichListFrom || enrichListFrom?.trim() === "") {
      toast.error("Please enter Name of Event/Conference/Purchased");
      return false;
    }
    else if (!enrichList || enrichList.trim() === "") {
      toast.error("Please enter enrich list");
      return false;
    }
    return true;
  };
  const enrichProspect = () => {
    if (!validate()) return;
    setLoading(true);
    const data = {
      organization: selectedValues.organization,
      website: selectedValues.website,
      linkedin: selectedValues.linkedInURL,
      street: selectedValues.streetAddress,
      city: selectedValues.city,
      state: selectedValues.state,
      zip_code: selectedValues.zipCode,
      status: "true",
      country: selectedValues.country,
      // user_filename: enrichList,
      // filename: file.filename+".csv",
      // filename: file.filename?.split("uploads/")?.[1],
    };
    const option = {
      method: "POST",
      headers: {
        "access-control-allow-origin": "*",
        "X-API-Key": APITokenUrl(),
      },
      url: `${APIDataUrl()}/v1/data-enrichment-csv-to-db-organization/?user_id=${userId}&category=organization&user_filename=${enrichList}&filename=${file.filename}&filepath=${filepath}&enrich_requested_by=${authorizedPerson}&list_from=${enrichListFrom}&list_type=${listSource}`,
      // url: `${APIDataUrl()}/v1/data-enrichment-mapping-organization?request_id=${requestId}`,
      data: data,
    };
    axios(option)
      .then((e) => {
        setResultTableData(e?.data?.data)
        //  setResultModalOpen(true);
        setIsOrgModalOpen(false);
        enrichProcessOrg();
        setDisclaimerTwo(false);
        setSelectedValues({
          organization: "",
          website: "",
          linkedInURL: "",
          streetAddress: "",
          city: "",
          state: "",
          zipCode: "",
          country: ""
        });
        setAuthorizedPerson("")
        setEnrichList("")
      })
      .catch((err) => {
        console.error('Error enriching prospect', err);
        setLoading(false);
      });
  };
  const enrichProcessOrg = () => {
    const data = {
    };
    const option = {
      method: "POST",
      headers: {
        "access-control-allow-origin": "*",
        "X-API-Key": APITokenUrl(),
      },
      url: `${APIDataUrl()}/v1/data-enrichment-process-organization/?filename=${file.filename}`,
      data: data,
    };

    axios(option)
      .then((res) => {
        toast.success("Data Enrich process completed successfully");
        setLoading(false);
        getEnrichList()
      })
      .catch((err) => {
        console.error('Error processing organization', err);
        setLoading(false);
      });
  };

  const handleCloseField = () => {
    setOrgUploadModal(false);
    handleClose(false);
    setEnrichList("");
    setSelectedValues({
      organization: "",
      website: "",
      linkedInURL: "",
      streetAddress: "",
      city: "",
      state: "",
      zipCode: "",
      country: ""
    });
    setAuthorizedPerson("")
    setDisclaimerOne("")
    setDisclaimerTwo("")
  };
  const handleBack = () => {
    handleClose(false);
    setOrgUploadModal(true);
    // setEnrichList("");
  };

  useEffect(() => {
    if (headersList.length > 0) {
      setSelectedValues((prevValues) => ({
        organization: headersList.includes("Organization") ? "Organization" : prevValues.organization,
        website: headersList.includes("Website") ? "Website" : prevValues.website,
        linkedInURL: headersList.includes("LinkedIn_URL") ? "LinkedIn_URL" : prevValues.linkedInURL,
        streetAddress: headersList.includes("Street_Address") ? "Street_Address" : prevValues.streetAddress,
        city: headersList.includes("City") ? "City" : prevValues.city,
        state: headersList.includes("State") ? "State" : prevValues.state,
        zipCode: headersList.includes("Zip_Code") ? "Zip_Code" : prevValues.zipCode,
        country: headersList.includes("Country") ? "Country" : prevValues.country
      }));
    }
  }, [headersList]);


  const handleProfileChange = (key, value) => {
    setSelectedValues({ ...selectedValues, [key]: value });
  };
  return (
    <>
      {loading ? <Loader /> : null}
      <Modal
        open={modalOpen}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <div className="vrufyerv">
          <Box sx={style}>
            <div className='de_overflow_cont'>
              <div className="de_pad">
                <h3>Field Mapping</h3>
                <p className='de_head'>Confirm your data is mapping correctly</p>
                <div className="de_input_cont">
                  <label htmlFor="">Organization <span>*</span></label>
                  <FormControlProfile
                    value={selectedValues.organization}
                    handleChange={(e) => handleProfileChange("organization", e)}
                    dataList={headersList}
                    selectedValues={Object.values(selectedValues)}
                  />
                </div>
              </div>
              <hr className='' />
              <div className="de_hr-org">
                <p className='de_red'>*Required 1 of these 2 fields is required</p>
                <div className="de_input_cont">
                  <label htmlFor="">Website</label>
                  <FormControlProfile
                    value={selectedValues.website}
                    handleChange={(e) => handleProfileChange("website", e)}
                    dataList={headersList}
                    selectedValues={Object.values(selectedValues)}
                  />
                </div>
                <div className="de_input_cont">
                  <label htmlFor="">LinkedIn URL</label>
                  <FormControlProfile
                    value={selectedValues.linkedInURL}
                    handleChange={(e) => handleProfileChange("linkedInURL", e)}
                    dataList={headersList}
                    selectedValues={Object.values(selectedValues)}
                  />
                </div>
              </div>
              <hr className='' />
              <div className="de_hr-org">
                <div className="de_input_cont">
                  <label htmlFor="">Street Address</label>
                  <FormControlProfile
                    value={selectedValues.streetAddress}
                    handleChange={(e) => handleProfileChange("streetAddress", e)}
                    dataList={headersList}
                    selectedValues={Object.values(selectedValues)}
                  />
                </div>
                <div className="de_input_cont">
                  <label htmlFor="">City</label>
                  <FormControlProfile
                    value={selectedValues.city}
                    handleChange={(e) => handleProfileChange("city", e)}
                    dataList={headersList}
                    selectedValues={Object.values(selectedValues)}
                  />
                </div>
                <div className="de_input_cont">
                  <label htmlFor="">State</label>
                  <FormControlProfile
                    value={selectedValues.state}
                    handleChange={(e) => handleProfileChange("state", e)}
                    dataList={headersList}
                    selectedValues={Object.values(selectedValues)}
                  />
                </div>
                <div className="de_input_cont">
                  <label htmlFor="">Zip Code</label>
                  <FormControlProfile
                    value={selectedValues.zipCode}
                    handleChange={(e) => handleProfileChange("zipCode", e)}
                    dataList={headersList}
                    selectedValues={Object.values(selectedValues)}
                  />
                </div>
                <div className="de_input_cont">
                  <label htmlFor="">Country</label>
                  <FormControlProfile
                    value={selectedValues.country}
                    handleChange={(e) => handleProfileChange("country", e)}
                    dataList={headersList}
                    selectedValues={Object.values(selectedValues)}
                  />
                </div>
              </div>
              <hr className='' />
              <div className="de_hr-org">

                <div className="de_input_cont">
                  <label htmlFor="" className="label-floating">
                    Where did the List Come From (Required) <span>*</span>
                  </label>
                  <FormControl sx={{ m: 1, minWidth: 120 }} className="Limit-people-per-company">
                    <Select
                      className="select-dropdown-leads"
                      value={listSource || ""}
                      onChange={(e) => setListSource(e.target.value)}
                      displayEmpty
                    >
                      <MenuItem value="" disabled className="heading-placeholder">
                        <em className="placeholder-heading">List Source</em>
                      </MenuItem>
                      {liveScoreData.map((item, index) => (
                        <MenuItem key={index} value={item.value} >
                          <ListItemText primary={item.label} className='orbit-strength-select-requpdate' />
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </div>

                <div className="de_input_cont">
                  <label htmlFor="">Event/Purchased/Other Description (Required) <span>*</span></label>
                  <input
                    type="text"
                    placeholder='Name'
                    value={enrichListFrom}
                    onChange={(e) => setEnrichListFrom(e?.target?.value)}
                  />
                </div>

                <div className="de_input_cont">
                  <label htmlFor="">Name your Enrich List (Required) <span>*</span></label>
                  <input
                    type="text"
                    placeholder='Name'
                    value={enrichList}
                    onChange={(e) => setEnrichList(e?.target?.value)}
                  />
                </div>
                <div className='de_btn_cont'>
                  <Button className='de_cancel' onClick={handleCloseField}>Cancel</Button>
                  <Button className='de_back' onClick={handleBack}>Back</Button>
                  <Button className='de_next' onClick={() => enrichProspect()}>Submit</Button>
                </div>
              </div>
            </div>
          </Box>
        </div>
      </Modal>
      {resultModalOpen ? <DataEnrichOrgResult modalOpen={resultModalOpen}
        handleClose={() => setResultModalOpen(false)}
        resultTableData={resultTableData} requestId={requestId}
        enrichList={enrichList} enrichListFrom={enrichListFrom} file={file} setIsOrgModalOpen={setIsOrgModalOpen}
        setEnrichList={setEnrichList} setOrgUploadModal={setOrgUploadModal}
        setSelectedValues={setSelectedValues} /> : null}
    </>
  );
};
export default DataEnrichOrgModal;